import { render, staticRenderFns } from "./jak-inwestowac-w-branze-motoryzacyjna.md?vue&type=template&id=c0fb180c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports